import script from "./register.vue?vue&type=script&setup=true&lang=js"
export * from "./register.vue?vue&type=script&setup=true&lang=js"

import "./register.vue?vue&type=style&index=0&id=a286a3e6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a286a3e6"]])

export default __exports__